<template>
    <div>
        <div style="margin-bottom: 20px;">
            <div>
                <van-cell-group>
                    <van-cell :title="title" style="padding-right: 0px">
                        <h3 slot="title">{{title}}</h3>
                        <template slot="right-icon">
                            <Wp_date_select @onDateSelect="selectDateCount" :default="0"></Wp_date_select>
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>

            <div v-if="income_list && income_list.length > 0" style="box-shadow: 1px 1px 5px #999999;">
                <van-row>
                    <van-col span="19">
                        <Wp_mini_data_card title=""
                                           :datas="income_list"
                                           :showRight="false"
                                           style="box-shadow: none">

                        </Wp_mini_data_card>
                    </van-col>

                    <van-col span="5">
                        <Wp_mini_data_card title=""
                                           :datas="income_all"
                                           :showRight="false"
                                           style="box-shadow: none; border-left: 1px solid #eeeeee;">

                        </Wp_mini_data_card>
                    </van-col>

                </van-row>

            </div>

        </div>
    </div>
</template>

<script>
    import Wp_date_select from "../../custom/Wp_date_select";
    import Wp_mini_data_card from "../../custom/Wp_mini_data_card";
    export default {
        name: "Wp_mt_my_child_num_income",
        components: {Wp_mini_data_card, Wp_date_select},

        data(){
            return{
                title: "今日数据",
                income_list: [],
                income_all:[],

                startTime: "",
                endTime: ""

            }
        },

        created(){
            // this.getLevelCountData();
        },

        methods:{

            getLevelCountData(){
                // let time = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
                let params = {
                    uid: this.$store.state.username,
                    stime: this.startTime,
                    etime: this.endTime
                }
                this.$getLevelCountData_mt(params, response=>{
                    if(response && response.code === 200){
                        if(response.u_type === 0){
                            this.income_list = [
                                {
                                    count: Number(response.efeetoday_two).toFixed(2),
                                    count_unit: "￥",
                                    text: "直属下级<br/>(" + response.efeetoday_two_num + ")"
                                },
                                {
                                    count: Number(response.efeetoday_three).toFixed(2),
                                    count_unit: "￥",
                                    text: "直属下下级<br/>(" + response.efeetoday_three_num + ")"
                                }
                            ];
                            this.income_all = [
                                {
                                    count: Number(response.efeetodayall).toFixed(2),
                                    count_unit: "￥",
                                    text: "总计<br/>(" + response.efeetodayall_num + ")"
                                }
                            ]
                        }else if(response.u_type === 1 || response.u_type === 2){
                            this.income_list = [
                                {
                                    count: Number(response.efeetoday_two).toFixed(2),
                                    count_unit: "￥",
                                    text: "直属下级<br/>(" + response.efeetoday_two_num + ")"
                                },
                                {
                                    count: Number(response.efeetoday_three).toFixed(2),
                                    count_unit: "￥",
                                    text: "直属下下级<br/>(" + response.efeetoday_three_num + ")"
                                },
                                {
                                    count: Number(response.efeetoday_other).toFixed(2),
                                    count_unit: "￥",
                                    text: "非直属<br/>(" + response.efeetoday_other_num + ")"
                                },
                                {
                                    count: Number(response.efeetodayall_he).toFixed(2),
                                    count_unit: "￥",
                                    text: "专属<br/>(" + response.efeetodayall_he_num + ")"
                                },

                            ];
                            this.income_all = [
                                {
                                    count: Number(response.efeetodayall).toFixed(2),
                                    count_unit: "￥",
                                    text: "总计<br/>(" + response.efeetodayall_num + ")"
                                }
                            ]
                        }
                    }
                })
            },


            selectDateCount(selectDate) {
                this.$log(selectDate);
                this.startTime = selectDate.startTime;
                this.endTime = selectDate.endTime;
                this.showTitle();
                this.getLevelCountData();
            },

            showTitle(){
                let testTime_1=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
                let testTime_2=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', -1, new Date()));
                if(testTime_1===this.startTime && testTime_1===this.endTime){
                    this.title='今日数据'
                }else  if(testTime_2===this.startTime && testTime_2===this.endTime){
                    this.title='昨日数据'
                }else if(this.startTime===this.endTime){
                    this.title='数据('+this.startTime+')'
                }else{
                    this.title=this.startTime+' 至 '+this.endTime+' 数据'
                }
            },
        }
    }
</script>

<style scoped>

</style>